/* ============================================================
   GH-912 — Stripe Managed Payments cohort helpers.
   Under Managed Payments, Stripe's Link is the seller of record for NEW
   subscriptions: checkout stays Stripe-hosted ("Sold through Link"), tax is
   calculated there from the billing address, and receipts/invoices come from
   Link (not from Dathent). The saved card is authorized only for Managed
   Payments charges, so our own SetupIntent "update card" form must not be
   used for this cohort; the Stripe Customer Portal is the supported path.

   Two booleans drive the SPA, both optional (absent = false) so the SPA keeps
   today's behaviour against a backend that doesn't send them yet:
     managedPayments                 GET /api/billing/entitlements — the org's
                                     subscription was sold through Link.
     managedPaymentsNewSubscriptions GET /api/billing/plans (stripe-worker,
                                     the flag that decides what a checkout
                                     creates) and GET /api/billing/entitlements
                                     (the gateway's display mirror of it).
   ============================================================ */

function payload(source) {
  if (!source || typeof source !== 'object') return {};
  return source.data && typeof source.data === 'object' ? source.data : source;
}

// The org's own subscription is in the Managed Payments cohort.
export function isManagedPaymentsSubscription(entitlements) {
  return payload(entitlements).managedPayments === true;
}

// Whether a NEW subscription started now would be sold through Link. The
// plans response comes from the stripe-worker itself, so its boolean wins
// whenever it is present; the entitlements mirror only answers while the
// plans response doesn't carry the field (older stripe-worker, or the catalog
// fetch hasn't resolved/failed).
export function resolveManagedPaymentsNewSubscriptions({ catalogFlag, entitlements } = {}) {
  if (typeof catalogFlag === 'boolean') return catalogFlag;
  return payload(entitlements).managedPaymentsNewSubscriptions === true;
}

// Reads the flag off a GET /api/billing/plans response (client-unwrapped or
// raw envelope). undefined when the response doesn't carry a boolean.
export function readCatalogManagedPaymentsFlag(plansResponse) {
  const value = payload(plansResponse).managedPaymentsNewSubscriptions;
  return typeof value === 'boolean' ? value : undefined;
}
